import React from "react";
import { BaseLegacyPaper } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function LegacyPaper(_ref) {
  var children = _ref.children,
    _ref$elevation = _ref.elevation,
    elevation = _ref$elevation === void 0 ? "md" : _ref$elevation,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? "lg" : _ref$padding;
  return /*#__PURE__*/_jsx(BaseLegacyPaper, {
    elevation: elevation,
    padding: padding,
    children: children
  });
}
export default LegacyPaper;